<template>
  <div class="w-full h-full relative">
    <PasswordReset />
    <div class="w-full absolute bottom-0 left-0 opacity-5 pointer-events-none">
      <img src="@/assets/images/backgrounds/register.webp" alt="" />
    </div>
    <div
      class="w-full h-full flex flex-col items-center justify-between relative"
    >
      <div></div>
      <div class="w-[80%] md:max-w-[350px]">
        <div class="text-center">
          <div class="text-2xl font-semibold whitespace-nowrap title-color">
            {{ $t('login.title') }}
          </div>
          <div class="py-1"></div>
          <div class="font-semibold whitespace-nowrap description-color">
            {{ $t('login.subTitle') }}
          </div>
          <div class="py-3"></div>
        </div>
        <FormComponent
          class="w-full grid grid-cols-1 gap-x-4"
          :fields="fields"
          :onFormSubmited="
            data => {
              requestLogin(data)
            }
          "
          :loading="false"
        >
          <template #submitButton>
            <button class="hidden" type="submit" ref="submit"></button>
            <button
              class="buttonComponent mt-4 arrow w-full"
              @click="$refs.submit.click()"
            >
              {{ $t('login.loginButton') }}
            </button>
          </template>
        </FormComponent>
        <div class="text-center pt-8">
          <span> {{ $t('login.noAccountQuestion') }} </span> &nbsp;
          <router-link to="/register" class="text-primary-400 font-bold">
            {{ $t('login.goToRegistrationButton') }}
          </router-link>
        </div>
        <div class="text-center pt-4">
          <span
            class="text-center text-primary-400 font-bold"
            @click="resetPassword"
          >
            {{ $t('login.passwordForgotButton') }}
          </span>
        </div>
      </div>
      <div class="flex justify-center py-6">
        <div class="top-0 text-3xl font-bold relative">
          <div
            class="w-8 top-0 right-0 absolute translate-x-2/3 -translate-y-1/2"
          >
            <img
              src="@/assets/images/king-recharge-assets/crown-white.svg"
              class="w-full"
              alt=""
            />
          </div>
          <div>King Recharge</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormComponent from '../utils/FormComponent.vue'
import PasswordReset from './PasswordReset.vue';

export default {
  components: { FormComponent, PasswordReset },
  data() {
    return {
      fields: [
        {
          type: 'email',
          propertyName: 'email',
          label: this.$t('login.loginEmailInputLabel'),
          defaultValue: '',
          required: true,
        },
        {
          type: 'password',
          propertyName: 'password',
          label: this.$t('login.loginPasswordInputLabel'),
          defaultValue: '',
          required: true,
        },
      ],
      eventsIds: [],
      loading: false,
    }
  },
  mounted() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    const id = this.$Events.handleEvent('login_done', this.onLoginDone)
    const id2 = this.$Events.handleEvent('login_failed', this.onLoginFailed)
    this.eventsIds.push(id)
    this.eventsIds.push(id2)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    async resetPassword() {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: 'Réinitialisation de mot de passe',
          subTitle: "Veuillez entrer l'email de votre compte",
          formFields: [
            {
              type: 'email',
              propertyName: 'email',
              label: 'Email de votre compte',
              defaultValue: '',
              required: true,
            },
          ],
          successText: 'Réinitialiser',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      // this.$Events.dispatchEvent('toast_notification', {
      //   title: 'Demande acceptée',
      //   body:
      //     "Vous recevrez un mail de réinitialisation sur l'adresse " +
      //     prompt.data.email,
      // })
      this.$Events.dispatchEvent('password_reset_required', {
        email: prompt.data.email,
        userName: "Mr/Mme",
      })
    },
    requestLogin(data) {
      if (this.loading) return
      this.loading = true
      this.$Events.dispatchEvent('start_loading')
      this.$Events.dispatchEvent('login_requested', data)
    },
    async onLoginDone() {
      this.loading = false
      this.$Events.dispatchEvent('finish_loading')
      await new Promise(r => setTimeout(r, 500))
      this.$router.push('/home')
      // window.location.reload();
    },
    onLoginFailed(data) {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        type: 'warning',
        title: this.$t('login.loginFailedTitle'),
        body:
          this.$t(data.messageId) || this.$t('login.loginFailedDefaultMessage'),
      })
      this.loading = false
    },
  },
}
</script>
